export default "__VITE_ASSET__BksHFf8h__"